import React from "react";

const Icon = ({ name }) => {
  const common = { width: 28, height: 28, viewBox: "0 0 24 24", fill: "none", stroke: "currentColor", strokeWidth: 1.6, strokeLinecap: "round", strokeLinejoin: "round" };
  switch (name) {
    case "briefcase":
      return (<svg {...common}><rect x="2" y="7" width="20" height="13" rx="2"/><path d="M16 7V6a2 2 0 0 0-2-2h-4a2 2 0 0 0-2 2v1"/><path d="M2 12h20"/></svg>);
    case "lock":
      return (<svg {...common}><rect x="4" y="11" width="16" height="9" rx="2"/><path d="M8 11V8a4 4 0 1 1 8 0v3"/></svg>);
    case "building":
      return (<svg {...common}><rect x="3" y="3" width="7" height="18" rx="1"/><rect x="14" y="8" width="7" height="13" rx="1"/><path d="M5.5 6h2M5.5 9h2M5.5 12h2M5.5 15h2M16.5 11h2M16.5 14h2M16.5 17h2"/></svg>);
    case "cog":
      return (<svg {...common}><path d="M12 8a4 4 0 1 0 0 8 4 4 0 0 0 0-8Z"/><path d="M3 12h2M19 12h2M12 3v2M12 19v2M18.36 5.64l-1.41 1.41M7.05 16.95l-1.41 1.41M5.64 5.64l1.41 1.41M16.95 16.95l1.41 1.41"/></svg>);
    case "shield":
      return (<svg {...common}><path d="M12 3 5 6v6a10 10 0 0 0 7 9 10 10 0 0 0 7-9V6l-7-3Z"/></svg>);
    case "key":
      return (<svg {...common}><circle cx="7" cy="14" r="3"/><path d="m10 14 11-11"/><path d="m12.5 5.5 2 2M15 8l2 2"/></svg>);
    case "users":
      return (<svg {...common}><path d="M16 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2"/><circle cx="9" cy="7" r="4"/><path d="M22 21v-2a4 4 0 0 0-3-3.87"/><path d="M16 3.13a4 4 0 0 1 0 7.75"/></svg>);
    default:
      return null;
  }
};

export default function About() {
  const values = [
    { title: "Yeni Nesil İş Geliştirme", desc: "Kurumsal toplantı ve etkinlik süreçlerini tek panelden planlayın, takip edin ve analiz edin.", icon: "briefcase" },
    { title: "Güvenli & Şifreli", desc: "Google güvenlik sistemleri ve uçtan uca şifreleme ile verileriniz maksimum güvenlik altında.", icon: "lock" },
    { title: "Kurumsal Odaklı", desc: "Mikro ve küçük ölçekli işletmeler için tasarlanmış kurumsal yetenekler.", icon: "building" },
    { title: "Kolay Yönetim", desc: "Kullanıcı dostu arayüzle toplantılarınızı dakikalar içinde organize edin.", icon: "cog" },
  ];

  const steps = [
    { no: 1, title: "Hesap Oluşturun", desc: "Telefon doğrulamasıyla güvenli bir hesap açın.", bullets: ["Ad–soyad ve şirket bilgileriniz", "Tek seferlik SMS doğrulama", "KVKK'ya uygun kayıt"] },
    { no: 2, title: "Firmanızı Doğrulayın", desc: "Kurumsal hesap için gerekli belgeleri yükleyin ve onay sürecini tamamlayın.", bullets: ["Ticari unvan ve vergi bilgileri", "Yetkili kişi doğrulaması"] },
    { no: 3, title: "Toplantı Akışını Planlayın", desc: "Gündem, katılımcı ve tarih/saat belirleyin; tekrarlı toplantılar için şablonlar kullanın.", bullets: [ "Takvim entegrasyonu ", "Hatırlatıcı bildirimler"] },
    { no: 4, title: "Güvenli İş Birliği", desc: "Notları paylaşın, görev atayın ve dosyaları şifreli biçimde saklayın.", bullets: [ "Şifreli not ve dosyalar", "Gerçek zamanlı eş zamanlama"] },
    { no: 5, title: "Analiz ve Raporlama", desc: "Katılım, süre, aksiyon ve sonuçları panodan izleyin.", bullets: [ "Görevlerin düzenli görünümü", "Dışa aktar (PDF)"] },
    { no: 6, title: "Ağınızı Genişletin", desc: "Kurumsal ağda yeni iş ortaklıkları keşfedin.", bullets: [ "Firma profilleri", "Güvenli mesajlaşma"] }
  ];

  const stats = [
    { k: "10K+", v: "aktif kullanıcı" },
    { k: "50K+", v: "aylık toplantı" },
    { k: "99.9%", v: "uptime" },
    { k: "30sn", v: "ortalama kurulum" },
  ];



  const faqs = [
    { q: "Beetinq nedir ve nasıl çalışır?", a: "Beetinq, toplantı yönetimi ve kurumsal iş ağı özelliklerini tek platformda sunan güvenli bir çözümdür." },
    { q: "Telefon numarası neden gerekli?", a: "Sahtekarlığı önlemek ve gerçek kullanımı sağlamak için SMS doğrulaması zorunludur." },
    { q: "Beetinq güvenli mi?", a: "Evet. Uçtan uca şifreleme ve Google güvenlik altyapıları ile korunur." },
    { q: "Toplantı notlarımı kimler görür?", a: "Notlar varsayılan olarak size özeldir. Paylaşım izinleriyle dilediğiniz kişilerle paylaşabilirsiniz." },

    { q: "Ücretlendirme nasıl?", a: "Mikro ve küçük işletmelere özel paketler bulunur. Yıllık/aylık ödeme seçenekleri mevcuttur." },
    { q: "İptal ve iade politikası nedir?", a: "Deneme süresi içinde iptal edebilir, kullanım süresine göre oransal iade alabilirsiniz." }
  ];

  return (
    <main className="about">
      {/* Hero */}
      <section className="about__hero">
        <h1 className="text-white">Yeni Nesil İş Geliştirme Ağı ve Toplantı Platformu</h1>
        <p className="about__lead">Toplantı yönetimi, güvenli iş birliği ve kurumsal ağ oluşturma — tek platformda.</p>
        <div className="cta__actions">
          <a className="btn btn--contrast" href="https://beetinq.com">Hemen Başla</a>
        </div>
      </section>

      {/* Value Props (2x2 grid) */}
      <section className="about__grid">
        {values.map((v) => (
          <article key={v.title} className="card" aria-label={v.title}>
            <div className="card__icon" aria-hidden><Icon name={v.icon} /></div>
            <div className="card__body">
              <h3>{v.title}</h3>
              <p>{v.desc}</p>
            </div>
          </article>
        ))}
      </section>

      {/* How it works */}
      <section className="about__steps" id="nasil-calisir">
        <h2>Nasıl Çalışır?</h2>
        <ol className="steps">
          {steps.map((s) => (
            <li key={s.no} className="step">
              <div className="step__header">
                <span className="steps__no">{s.no}</span>
                <h3>{s.title}</h3>
              </div>
              <p className="step__desc">{s.desc}</p>
              <ul className="step__bullets">
                {s.bullets.map((b) => (<li key={b}><span className="step__check">✓</span>{b}</li>))}
              </ul>
            </li>
          ))}
        </ol>
      </section>

      {/* Stats */}
      <section className="about__stats" aria-label="Öne çıkan sayılar">
        {stats.map((s) => (
          <div key={s.v} className="stat">
            <div className="stat__k">{s.k}</div>
            <div className="stat__v">{s.v}</div>
          </div>
        ))}
      </section>

      {/* Security */}
      <section className="about__security">
        <h2>Güvenlik ve Gizlilik</h2>
        <div className="security">
          <article className="security__item">
            <div className="security__icon"><Icon name="shield"/></div>
            <h3>Google Güvenlik Sistemleri</h3>
            <p>Endüstri standardı güvenlik protokolleri ile verilerinizi koruyoruz.</p>
          </article>
          <article className="security__item">
            <div className="security__icon"><Icon name="key"/></div>
            <h3>Uçtan Uca Şifreleme</h3>
            <p>Toplantı notları ve kişisel verileriniz şifrelenerek saklanır.</p>
          </article>
          <article className="security__item">
            <div className="security__icon"><Icon name="users"/></div>
            <h3>KVKK Uyumluluğu</h3>
            <p>Kişisel verileriniz korunur, okunmaz ve üçüncü kişilerle paylaşılmaz.</p>
          </article>
        </div>
      </section>

      {/* FAQ + Contact (üst/alt) */}
      <section className="about__faq">
        <h2>Sık Sorulanlar</h2>
        <div className="faq">
          {faqs.map((f) => (
            <details key={f.q}>
              <summary>{f.q}</summary>
              <p>{f.a}</p>
            </details>
          ))}
        </div>
        <div className="contact">
          <h3>İletişim</h3>
          <p><strong>Telefon:</strong> +90 540 233 8467</p>
          <p><strong>Telefon:</strong> +90 532 170 7428</p>
          <p><strong>Destek:</strong> info@beetinq.com <span className="muted">(09:00 - 17:00)</span></p>
          <p><strong>Adres:</strong> Elazığ, Türkiye</p>
        </div>
      </section>

     
      {/* CTA */}
      <section className="about__cta">
        <h2 className="text-white">Beetinq'i İşletmenizde Deneyin</h2>
        <p>Hemen başlayın ve toplantı süreçlerinizi dijitalleştirin.</p>
        <div className="cta__actions">
          <a className="btn btn--light" href="https://beetinq.com">Hemen Başla</a>
        </div>
      </section>

      <style>{`
        /* ===== Theme ===== */
        :root {
          --bg: #ffffff;
          --bg-soft: #F9FAFB;
          --card: #ffffff;
          --text: #0F172A;
          --text-soft: #475569;
          --brand: #60A5FA;
          --brand-strong: #3B82F6;
          --border: #E5E7EB;
          --shadow: 0 6px 20px rgba(2, 6, 23, 0.06);
          --radius: 14px;
        }

        .about { max-width: 1200px; margin: 0 auto; padding: 24px; color: var(--text); font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif; box-sizing: border-box; width: 100%; }
        .about *, .about *::before, .about *::after { box-sizing: border-box; }

        /* ===== Hero ===== */
        .about__hero { text-align: center; padding: 44px 24px; background: var(--brand); color: #fff; border-radius: var(--radius); margin-bottom: 36px; box-shadow: var(--shadow); }
        .about__hero h1 { font-size: 2rem; font-weight: 800; margin-bottom: 12px; line-height: 1.25; letter-spacing: -0.02em; }
        .about__lead { font-size: 1rem; opacity: 0.95; max-width: 680px; margin: 0 auto 18px; line-height: 1.6; }

        /* ===== Buttons ===== */
        .cta__actions { display: flex; gap: 12px; justify-content: center; flex-wrap: wrap; }
        .btn { padding: 12px 20px; border-radius: 10px; text-decoration: none; font-weight: 600; transition: transform .18s ease, box-shadow .18s ease, background .18s ease, color .18s ease; display: inline-block; border: 1px solid transparent; box-shadow: 0 4px 14px rgba(2,6,23,.08); }
        .btn:active { transform: translateY(1px); }
        .btn--contrast { background: #fff; color: var(--brand-strong); }
        .btn--contrast:hover { background: var(--bg-soft); }
        .btn--light { background: #fff; color: var(--brand-strong); }
        .btn--light:hover { background: var(--bg-soft); }

        /* ===== Cards Grid ===== */
        .about__grid { display: grid; grid-template-columns: repeat(2, minmax(320px, 1fr)); gap: 28px; margin: 56px 0; }
        .card { background: var(--card); padding: 28px; border-radius: var(--radius); box-shadow: var(--shadow); border: 1px solid var(--border); display: flex; align-items: flex-start; gap: 16px; transition: transform .18s ease, box-shadow .18s ease; }
        .card:hover { transform: translateY(-3px); box-shadow: 0 12px 26px rgba(2,6,23,.09); }
        .card__icon { color: var(--brand-strong); line-height: 0; }
        .card__body h3 { font-size: 1.15rem; font-weight: 800; margin: 2px 0 6px; }
        .card__body p { color: var(--text-soft); line-height: 1.65; }

        /* ===== Steps ===== */
        .about__steps { margin: 56px 0; background: var(--card); padding: 40px 36px; border-radius: var(--radius); box-shadow: var(--shadow); border: 1px solid var(--border); }
        .about__steps h2 { text-align: center; margin-bottom: 32px; font-size: 1.8rem; }
        .steps { list-style: none; padding: 0; margin: 0; display: grid; grid-template-columns: repeat(auto-fit, minmax(280px, 1fr)); gap: 20px; }
        .step { background: #f8f9ff; border: 1px solid #e8eaf6; border-radius: 12px; padding: 22px 20px; display: flex; flex-direction: column; gap: 10px; transition: box-shadow 0.2s, transform 0.2s; min-width: 0; }
        .step:hover { box-shadow: 0 6px 20px rgba(95,96,185,0.12); transform: translateY(-2px); }
        .step__header { display: flex; align-items: center; gap: 12px; }
        .step__header h3 { margin: 0; font-size: 1rem; font-weight: 700; color: #1a1a2e; min-width: 0; word-break: break-word; }
        .steps__no { background: var(--brand-strong); color: #fff; width: 34px; height: 34px; border-radius: 50%; display: flex; align-items: center; justify-content: center; font-weight: 800; font-size: 0.9rem; flex-shrink: 0; }
        .step__desc { color: var(--text-soft); margin: 0; font-size: 0.88rem; line-height: 1.6; word-break: break-word; }
        .step__bullets { margin: 0; padding: 0; list-style: none; display: flex; flex-direction: column; gap: 5px; }
        .step__bullets li { display: flex; align-items: flex-start; gap: 7px; color: var(--text-soft); font-size: 0.85rem; word-break: break-word; }
        .step__check { color: var(--brand-strong); font-weight: 700; flex-shrink: 0; margin-top: 1px; }

        /* ===== Stats ===== */
        .about__stats { display: grid; grid-template-columns: repeat(4, 1fr); gap: 16px; margin: 56px 0; }
        .stat { text-align: center; background: var(--card); padding: 20px 16px; border-radius: var(--radius); box-shadow: var(--shadow); border: 1px solid var(--border); }
        .stat__k { font-size: 2rem; font-weight: 800; margin-bottom: 4px; color: var(--brand-strong); }
        .stat__v { color: var(--text-soft); font-size: 1rem; }

        /* ===== Security ===== */
        .about__security { margin: 56px 0; }
        .about__security h2 { text-align: center; margin-bottom: 24px; font-size: 1.8rem; }
        .security { display: grid; grid-template-columns: repeat(3, 1fr); gap: 24px; }
        .security__item { text-align: center; padding: 26px 20px; background: var(--card); border-radius: var(--radius); box-shadow: var(--shadow); border: 1px solid var(--border); }
        .security__item h3 { font-size: 1rem; font-weight: 700; margin: 8px 0 6px; color: #1a1a2e; }
        .security__item p { font-size: 0.875rem; color: var(--text-soft); line-height: 1.6; margin: 0; }
        .security__icon { color: var(--brand-strong); margin-bottom: 6px; line-height: 0; }

        /* ===== FAQ + Contact ===== */
        .about__faq { margin: 56px 0; }
        .about__faq h2 { text-align: center; margin-bottom: 18px; font-size: 1.8rem; }
        .faq { background: var(--card); border: 1px solid var(--border); box-shadow: var(--shadow); border-radius: var(--radius); padding: 24px; }
        .faq details { margin-bottom: 12px; border-bottom: 1px solid var(--border); padding-bottom: 12px; }
        .faq summary { cursor: pointer; font-weight: 700; color: var(--text); }
        .faq details p { color: var(--text-soft); line-height: 1.65; margin-top: 8px; }
        .contact { margin-top: 16px; background: var(--card); border: 1px solid var(--border); box-shadow: var(--shadow); border-radius: var(--radius); padding: 24px; }
        .contact h3 { margin-bottom: 10px; font-size: 1.2rem; }
        .muted { color: #64748B; }

        /* ===== Timeline ===== */
        .about__timeline { margin: 56px 0; }
        .about__timeline h2 { text-align: center; margin-bottom: 24px; font-size: 1.8rem; }
        .timeline { position: relative; padding: 8px 0; }
        .timeline::before { content: ''; position: absolute; left: 20px; top: 0; bottom: 0; width: 2px; background: var(--brand); opacity: .35; }
        .timeline__item { display: flex; gap: 18px; margin-bottom: 20px; position: relative; }
        .timeline__dot { width: 12px; height: 12px; background: var(--brand); border-radius: 50%; margin-left: 14px; margin-top: 8px; flex-shrink: 0; box-shadow: 0 0 0 4px rgba(59,130,246,0.15); }
        .timeline__year { color: var(--brand-strong); font-weight: 800; font-size: 1rem; }
        .timeline h3 { margin: 2px 0 6px 0; font-size: 1.05rem; }
        .timeline p { color: var(--text-soft); line-height: 1.65; }

        /* ===== CTA ===== */
        .about__cta { text-align: center; padding: 56px 28px; background: var(--brand); color: #fff; border-radius: var(--radius); margin: 56px 0; box-shadow: var(--shadow); }
        .about__cta h2 { font-size: 1.8rem; margin-bottom: 10px; }
        .about__cta p { font-size: 1.05rem; opacity: 0.95; margin-bottom: 18px; }

        /* ===== Responsive (must be last) ===== */
        @media (max-width: 900px) { .about__grid { grid-template-columns: 1fr; } }
        @media (max-width: 767px) {
          .about { padding: 12px; overflow-x: hidden; }
          .about__hero { padding: 32px 16px; margin-bottom: 20px; }
          .about__hero h1 { font-size: 1.5rem; line-height: 1.3; margin-bottom: 10px; }
          .about__lead { font-size: 0.9rem; margin-bottom: 16px; }
          .about__steps { padding: 20px 12px; margin: 20px 0; }
          .steps { grid-template-columns: 1fr !important; gap: 12px; width: 100%; }
          .step { padding: 16px 14px; }
          .about__stats { grid-template-columns: repeat(2, 1fr); gap: 10px; margin: 20px 0; }
          .security { grid-template-columns: 1fr; gap: 12px; }
        }
      `}</style>
    </main>
  );
}
